var _defs, _g, _g2, _g3, _g4, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 888 156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.86328-.00781h86v128.90625h-86V-.00781zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.22266 77.14062 78.75391 0c-15.78125 12.87109-18.09766 36.04687-5.16797 51.76172l63.46875 77.13672c15.78125-12.8711 18.09375-36.04688 5.16797-51.75782zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.86328 18.28906h104v110.60938h-104V18.28906zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.04687 77.5 48.21094 18.6289C36.16406 35.02344 39.75 58.03515 56.21875 70.02734l80.83594 58.8711c12.04297-16.39454 8.46093-39.40625-8.00782-51.39844zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.86328 51.28906h124v77.60938h-124V51.28906zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.47266 82.48437 18.3125 51.39062c-6.36328 19.30078 4.19531 40.08203 23.57812 46.41797l95.16407 31.08985c6.35937-19.30079-4.19922-40.08204-23.58203-46.41407zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.00391 91.28906h137.86719v37.60938H-.00391V91.28906zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.21094 92.02344.05469 91.75781C0 112.07031 16.49609 128.58203 36.89844 128.63672l100.15625.26172c.05078-20.3125-16.44141-36.82422-36.84375-36.875zm0 0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0.37276,
    x2: 0.62743,
    y1: 1.04628,
    y2: -0.04625
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#300000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#300000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07813,
    stopColor: "#300000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08594,
    stopColor: "#300000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08984,
    stopColor: "#310000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#320000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09766,
    stopColor: "#300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10156,
    stopColor: "#350101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10547,
    stopColor: "#360101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10938,
    stopColor: "#370101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11328,
    stopColor: "#390101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11719,
    stopColor: "#3A0101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12109,
    stopColor: "#3B0101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#3D0202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12891,
    stopColor: "#3E0202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13281,
    stopColor: "#3F0202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13672,
    stopColor: "#410202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14063,
    stopColor: "#420202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14453,
    stopColor: "#430202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14844,
    stopColor: "#450202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15234,
    stopColor: "#460303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#470303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16016,
    stopColor: "#490303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16406,
    stopColor: "#4A0303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16797,
    stopColor: "#4B0303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17188,
    stopColor: "#4D0303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17578,
    stopColor: "#4E0404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17969,
    stopColor: "#4F0404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18359,
    stopColor: "#510404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#520404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19141,
    stopColor: "#530404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19531,
    stopColor: "#550404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19922,
    stopColor: "#560505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20313,
    stopColor: "#570505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20703,
    stopColor: "#590505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21094,
    stopColor: "#5A0505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21484,
    stopColor: "#5B0505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#5D0505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22266,
    stopColor: "#5E0606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22656,
    stopColor: "#5F0606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23047,
    stopColor: "#610606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23438,
    stopColor: "#620606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23828,
    stopColor: "#630606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24219,
    stopColor: "#650606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24609,
    stopColor: "#660707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#680707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25391,
    stopColor: "#690707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25781,
    stopColor: "#6A0707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26172,
    stopColor: "#6C0707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26563,
    stopColor: "#6D0707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26953,
    stopColor: "#6E0808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27344,
    stopColor: "#700808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27734,
    stopColor: "#710808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#720808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28516,
    stopColor: "#740808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28906,
    stopColor: "#750808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29297,
    stopColor: "#760808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29688,
    stopColor: "#780909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.30078,
    stopColor: "#790909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.30469,
    stopColor: "#7A0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.30859,
    stopColor: "#7C0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#7D0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31641,
    stopColor: "#7E0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32031,
    stopColor: "#800A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32422,
    stopColor: "#810A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32813,
    stopColor: "#820A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33203,
    stopColor: "#840A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33594,
    stopColor: "#850A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33984,
    stopColor: "#860A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#880B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34766,
    stopColor: "#890B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35156,
    stopColor: "#8A0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35547,
    stopColor: "#8C0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35938,
    stopColor: "#8D0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36328,
    stopColor: "#8E0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36719,
    stopColor: "#900C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37109,
    stopColor: "#910C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#920C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37891,
    stopColor: "#940C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38281,
    stopColor: "#950C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38672,
    stopColor: "#960C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39063,
    stopColor: "#980D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39453,
    stopColor: "#990D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39844,
    stopColor: "#9B0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40234,
    stopColor: "#9C0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#9D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41016,
    stopColor: "#9F0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41406,
    stopColor: "#A00E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41797,
    stopColor: "#A10E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42188,
    stopColor: "#A30E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42578,
    stopColor: "#A40E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42969,
    stopColor: "#A50E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43359,
    stopColor: "#A70E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#A80E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44141,
    stopColor: "#A90F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44531,
    stopColor: "#AB0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44922,
    stopColor: "#AC0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45313,
    stopColor: "#AD0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45703,
    stopColor: "#AF0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46094,
    stopColor: "#B00F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46484,
    stopColor: "#B11010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#B31010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47266,
    stopColor: "#B41010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47656,
    stopColor: "#B51010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48047,
    stopColor: "#B71010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48438,
    stopColor: "#B81010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48828,
    stopColor: "#B91111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49219,
    stopColor: "#B11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49609,
    stopColor: "#BC1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#BD1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.50391,
    stopColor: "#BF1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.50781,
    stopColor: "#C01111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51172,
    stopColor: "#C11212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51563,
    stopColor: "#C31212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51953,
    stopColor: "#C41212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52344,
    stopColor: "#C51212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52734,
    stopColor: "#C71212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#C81212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53516,
    stopColor: "#C91313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53906,
    stopColor: "#CB1313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54297,
    stopColor: "#CC1313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54688,
    stopColor: "#CE1313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55078,
    stopColor: "#CF1313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55469,
    stopColor: "#D01313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55859,
    stopColor: "#D21414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#D31414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56641,
    stopColor: "#D41414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57031,
    stopColor: "#D61414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57422,
    stopColor: "#D71414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57813,
    stopColor: "#D81414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58203,
    stopColor: "#DA1414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58594,
    stopColor: "#DB1515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58984,
    stopColor: "#DC1515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#DE1515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59766,
    stopColor: "#DF1515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60156,
    stopColor: "#E01515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60547,
    stopColor: "#E21515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60938,
    stopColor: "#E31616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61328,
    stopColor: "#E41616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61719,
    stopColor: "#E61616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62109,
    stopColor: "#E71616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#E81616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62891,
    stopColor: "#EA1616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63281,
    stopColor: "#EB1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63672,
    stopColor: "#EC1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64063,
    stopColor: "#EE1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64453,
    stopColor: "#EF1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64844,
    stopColor: "#F01717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65234,
    stopColor: "#F21717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#F31818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66016,
    stopColor: "#F41818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66406,
    stopColor: "#F61818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66797,
    stopColor: "#F71818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67188,
    stopColor: "#F81818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67578,
    stopColor: "#FA1818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67969,
    stopColor: "#FB1919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68359,
    stopColor: "#FC1919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FE1919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69141,
    stopColor: "#FE1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69531,
    stopColor: "#FF1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69922,
    stopColor: "#FF1B1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70313,
    stopColor: "#FF1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70703,
    stopColor: "#FF1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71094,
    stopColor: "#FF1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71484,
    stopColor: "#FF2020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#FF2121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72266,
    stopColor: "#F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72656,
    stopColor: "#FF2323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73047,
    stopColor: "#FF2424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73438,
    stopColor: "#FF2525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73828,
    stopColor: "#FF2727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74219,
    stopColor: "#FF2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74609,
    stopColor: "#FF2929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75391,
    stopColor: "#FF2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75781,
    stopColor: "#FF2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76172,
    stopColor: "#FF2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76563,
    stopColor: "#FF2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76953,
    stopColor: "#FF2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77344,
    stopColor: "#FF3131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77734,
    stopColor: "#FF3232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78516,
    stopColor: "#FF3434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78906,
    stopColor: "#FF3535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79297,
    stopColor: "#FF3636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79688,
    stopColor: "#FF3737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.80078,
    stopColor: "#FF3838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.80469,
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.80859,
    stopColor: "#FF3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FF3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81641,
    stopColor: "#FF3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82031,
    stopColor: "#FF3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82422,
    stopColor: "#FF3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82813,
    stopColor: "#FF4040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83203,
    stopColor: "#FF4141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83594,
    stopColor: "#FF4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83984,
    stopColor: "#F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#FF4545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84766,
    stopColor: "#FF4646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85156,
    stopColor: "#FF4747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85547,
    stopColor: "#FF4848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85938,
    stopColor: "#FF4949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86328,
    stopColor: "#FF4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86719,
    stopColor: "#FF4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87109,
    stopColor: "#FF4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FF4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87891,
    stopColor: "#FF4F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88281,
    stopColor: "#FF5050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88672,
    stopColor: "#FF5151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89063,
    stopColor: "#FF5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89453,
    stopColor: "#FF5353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89844,
    stopColor: "#FF5454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90234,
    stopColor: "#F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FF5656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91016,
    stopColor: "#FF5858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91406,
    stopColor: "#FF5959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91797,
    stopColor: "#FF5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92188,
    stopColor: "#FF5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92578,
    stopColor: "#FF5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92969,
    stopColor: "#FF5D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93359,
    stopColor: "#FF5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#FF5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94141,
    stopColor: "#FF6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94531,
    stopColor: "#FF6262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94922,
    stopColor: "#FF6363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95313,
    stopColor: "#FF6464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95703,
    stopColor: "#FF6565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96094,
    stopColor: "#F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96484,
    stopColor: "#FF6767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#FF6868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97266,
    stopColor: "#FF6969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97656,
    stopColor: "#FF6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98047,
    stopColor: "#FF6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98438,
    stopColor: "#FF6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98828,
    stopColor: "#FF6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99219,
    stopColor: "#FF6F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99609,
    stopColor: "#FF7070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7171"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.47997,
    x2: 0.52005,
    y1: 1.01927,
    y2: -0.01928
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#300000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01563,
    stopColor: "#300000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02344,
    stopColor: "#300000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02734,
    stopColor: "#320000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03516,
    stopColor: "#350101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03906,
    stopColor: "#360101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04297,
    stopColor: "#380101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04688,
    stopColor: "#390101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05078,
    stopColor: "#3B0101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05469,
    stopColor: "#3C0101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05859,
    stopColor: "#3E0202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#3F0202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06641,
    stopColor: "#410202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07031,
    stopColor: "#420202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07422,
    stopColor: "#430202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07813,
    stopColor: "#450303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08203,
    stopColor: "#460303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08594,
    stopColor: "#480303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08984,
    stopColor: "#490303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#4B0303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09766,
    stopColor: "#4C0303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10156,
    stopColor: "#4E0404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10547,
    stopColor: "#4F0404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10938,
    stopColor: "#510404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11328,
    stopColor: "#520404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11719,
    stopColor: "#540404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12109,
    stopColor: "#550404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#570505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12891,
    stopColor: "#580505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13281,
    stopColor: "#5A0505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13672,
    stopColor: "#5B0505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14063,
    stopColor: "#5C0505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14453,
    stopColor: "#5E0606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14844,
    stopColor: "#5F0606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15234,
    stopColor: "#610606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#620606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16016,
    stopColor: "#640606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16406,
    stopColor: "#650606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16797,
    stopColor: "#670707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17188,
    stopColor: "#680707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17578,
    stopColor: "#6A0707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17969,
    stopColor: "#6B0707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18359,
    stopColor: "#6D0707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#6E0707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19141,
    stopColor: "#700808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19531,
    stopColor: "#710808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19922,
    stopColor: "#720808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20313,
    stopColor: "#740808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20703,
    stopColor: "#750808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21094,
    stopColor: "#770909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21484,
    stopColor: "#780909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#7A0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22266,
    stopColor: "#7B0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22656,
    stopColor: "#7D0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23047,
    stopColor: "#7E0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23438,
    stopColor: "#800A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23828,
    stopColor: "#810A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24219,
    stopColor: "#830A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24609,
    stopColor: "#840A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#860A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25391,
    stopColor: "#870B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25781,
    stopColor: "#890B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26172,
    stopColor: "#8A0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26563,
    stopColor: "#8B0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26953,
    stopColor: "#8D0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27344,
    stopColor: "#8E0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27734,
    stopColor: "#900C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#910C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28516,
    stopColor: "#930C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28906,
    stopColor: "#940C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29297,
    stopColor: "#960C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29688,
    stopColor: "#970C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.30078,
    stopColor: "#990D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.30469,
    stopColor: "#9A0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.30859,
    stopColor: "#9C0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#9D0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31641,
    stopColor: "#9F0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32031,
    stopColor: "#A00E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32422,
    stopColor: "#A20E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32813,
    stopColor: "#A30E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33203,
    stopColor: "#A40E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33594,
    stopColor: "#A60E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33984,
    stopColor: "#A70E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#A90F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34766,
    stopColor: "#AA0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35156,
    stopColor: "#AC0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35547,
    stopColor: "#AD0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35938,
    stopColor: "#AF0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36328,
    stopColor: "#B00F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36719,
    stopColor: "#B21010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37109,
    stopColor: "#B31010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#B51010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37891,
    stopColor: "#B61010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38281,
    stopColor: "#B81010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38672,
    stopColor: "#B91111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39063,
    stopColor: "#B11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39453,
    stopColor: "#BC1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39844,
    stopColor: "#BD1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40234,
    stopColor: "#BF1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#C01111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41016,
    stopColor: "#C21212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41406,
    stopColor: "#C31212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41797,
    stopColor: "#C51212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42188,
    stopColor: "#C61212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42578,
    stopColor: "#C81212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42969,
    stopColor: "#C91313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43359,
    stopColor: "#CB1313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#CC1313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44141,
    stopColor: "#CE1313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44531,
    stopColor: "#CF1313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44922,
    stopColor: "#D11313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45313,
    stopColor: "#D21414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45703,
    stopColor: "#D41414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46094,
    stopColor: "#D51414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46484,
    stopColor: "#D61414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#D81414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47266,
    stopColor: "#D91414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47656,
    stopColor: "#DB1515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48047,
    stopColor: "#DC1515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48438,
    stopColor: "#DE1515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48828,
    stopColor: "#DF1515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49219,
    stopColor: "#E11515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49609,
    stopColor: "#E21616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E41616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.50391,
    stopColor: "#E51616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.50781,
    stopColor: "#E71616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51172,
    stopColor: "#E81616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51563,
    stopColor: "#EA1616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51953,
    stopColor: "#EB1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52344,
    stopColor: "#ED1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52734,
    stopColor: "#EE1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#EF1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53516,
    stopColor: "#F11717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53906,
    stopColor: "#F21717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54297,
    stopColor: "#F41818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54688,
    stopColor: "#F51818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55078,
    stopColor: "#F71818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55469,
    stopColor: "#F81818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55859,
    stopColor: "#FA1818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FB1919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56641,
    stopColor: "#FD1919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57031,
    stopColor: "#FE1919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57422,
    stopColor: "#FF1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57813,
    stopColor: "#FF1B1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58203,
    stopColor: "#FF1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58594,
    stopColor: "#FF1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58984,
    stopColor: "#FF1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#FF2020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59766,
    stopColor: "#FF2121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60156,
    stopColor: "#F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60547,
    stopColor: "#FF2323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60938,
    stopColor: "#FF2525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61328,
    stopColor: "#FF2626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61719,
    stopColor: "#FF2727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62109,
    stopColor: "#FF2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FF2929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62891,
    stopColor: "#FF2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63281,
    stopColor: "#FF2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63672,
    stopColor: "#FF2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64063,
    stopColor: "#FF2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64453,
    stopColor: "#FF3030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64844,
    stopColor: "#FF3131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65234,
    stopColor: "#FF3232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66016,
    stopColor: "#FF3434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66406,
    stopColor: "#FF3636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66797,
    stopColor: "#FF3737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67188,
    stopColor: "#FF3838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67578,
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67969,
    stopColor: "#FF3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68359,
    stopColor: "#FF3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FF3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69141,
    stopColor: "#FF3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69531,
    stopColor: "#FF3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69922,
    stopColor: "#FF4141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70313,
    stopColor: "#FF4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70703,
    stopColor: "#FF4343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71094,
    stopColor: "#F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71484,
    stopColor: "#FF4646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#FF4747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72266,
    stopColor: "#FF4848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72656,
    stopColor: "#FF4949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73047,
    stopColor: "#FF4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73438,
    stopColor: "#FF4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73828,
    stopColor: "#FF4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74219,
    stopColor: "#FF4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74609,
    stopColor: "#FF4F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF5151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75391,
    stopColor: "#FF5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75781,
    stopColor: "#FF5353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76172,
    stopColor: "#FF5454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76563,
    stopColor: "#F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76953,
    stopColor: "#FF5757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77344,
    stopColor: "#FF5858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77734,
    stopColor: "#FF5959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FF5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78516,
    stopColor: "#FF5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78906,
    stopColor: "#FF5D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79297,
    stopColor: "#FF5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79688,
    stopColor: "#FF5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.80078,
    stopColor: "#FF6060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.80469,
    stopColor: "#FF6262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.80859,
    stopColor: "#FF6363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FF6464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81641,
    stopColor: "#FF6565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82031,
    stopColor: "#FF6767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82422,
    stopColor: "#FF6868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82813,
    stopColor: "#FF6969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83203,
    stopColor: "#FF6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83594,
    stopColor: "#FF6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83984,
    stopColor: "#FF6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#FF6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84766,
    stopColor: "#FF6F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85156,
    stopColor: "#FF7070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85547,
    stopColor: "#FF7272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85938,
    stopColor: "#FF7373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86328,
    stopColor: "#FF7474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86719,
    stopColor: "#FF7575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87109,
    stopColor: "#FF7676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FF7878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87891,
    stopColor: "#FF7979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88281,
    stopColor: "#FF7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88672,
    stopColor: "#FF7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89063,
    stopColor: "#FF7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89453,
    stopColor: "#FF7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89844,
    stopColor: "#FF7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90234,
    stopColor: "#FF8080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FF8181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91016,
    stopColor: "#FF8383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91406,
    stopColor: "#FF8484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91797,
    stopColor: "#FF8585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92188,
    stopColor: "#FF8686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92578,
    stopColor: "#F88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92969,
    stopColor: "#FF8989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93359,
    stopColor: "#FF8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#FF8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94141,
    stopColor: "#FF8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94531,
    stopColor: "#FF8E8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94922,
    stopColor: "#FF8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95313,
    stopColor: "#FF9090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95703,
    stopColor: "#FF9191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96094,
    stopColor: "#FF9393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96484,
    stopColor: "#FF9494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#FF9595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97266,
    stopColor: "#FF9696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97656,
    stopColor: "#FF9797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98047,
    stopColor: "#F99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98438,
    stopColor: "#FF9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98828,
    stopColor: "#FF9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99219,
    stopColor: "#FF9C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99609,
    stopColor: "#FF9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9F9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.51358,
    x2: 0.48642,
    y1: 1.03521,
    y2: -0.03519
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#300000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00781,
    stopColor: "#300000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01172,
    stopColor: "#310000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01563,
    stopColor: "#310000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01953,
    stopColor: "#300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02344,
    stopColor: "#350101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02734,
    stopColor: "#360101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#380101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03516,
    stopColor: "#3A0101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03906,
    stopColor: "#3B0101"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04297,
    stopColor: "#3D0202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04688,
    stopColor: "#3F0202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05078,
    stopColor: "#400202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05469,
    stopColor: "#420202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05859,
    stopColor: "#430202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#450303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06641,
    stopColor: "#470303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07031,
    stopColor: "#480303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07422,
    stopColor: "#4A0303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07813,
    stopColor: "#4C0303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08203,
    stopColor: "#4D0404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08594,
    stopColor: "#4F0404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08984,
    stopColor: "#510404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#520404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09766,
    stopColor: "#540404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10156,
    stopColor: "#560505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10547,
    stopColor: "#570505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10938,
    stopColor: "#590505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11328,
    stopColor: "#5A0505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11719,
    stopColor: "#5C0505"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12109,
    stopColor: "#5E0606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#5F0606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12891,
    stopColor: "#610606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13281,
    stopColor: "#630606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13672,
    stopColor: "#640606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14063,
    stopColor: "#660707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14453,
    stopColor: "#680707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14844,
    stopColor: "#690707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15234,
    stopColor: "#6B0707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#6D0707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16016,
    stopColor: "#6E0808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16406,
    stopColor: "#700808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16797,
    stopColor: "#710808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17188,
    stopColor: "#730808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17578,
    stopColor: "#750808"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17969,
    stopColor: "#760909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18359,
    stopColor: "#780909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#7A0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19141,
    stopColor: "#7B0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19531,
    stopColor: "#7D0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19922,
    stopColor: "#7F0909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20313,
    stopColor: "#800A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20703,
    stopColor: "#820A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21094,
    stopColor: "#840A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21484,
    stopColor: "#850A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#870A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22266,
    stopColor: "#880B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22656,
    stopColor: "#8A0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23047,
    stopColor: "#8C0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23438,
    stopColor: "#8D0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23828,
    stopColor: "#8F0B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24219,
    stopColor: "#910C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24609,
    stopColor: "#920C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#940C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25391,
    stopColor: "#960C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25781,
    stopColor: "#970C0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26172,
    stopColor: "#990D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26563,
    stopColor: "#9B0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26953,
    stopColor: "#9C0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27344,
    stopColor: "#9E0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27734,
    stopColor: "#9F0D0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#A10E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28516,
    stopColor: "#A30E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28906,
    stopColor: "#A40E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29297,
    stopColor: "#A60E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29688,
    stopColor: "#A80E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.30078,
    stopColor: "#A90F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.30469,
    stopColor: "#AB0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.30859,
    stopColor: "#AD0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#AE0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31641,
    stopColor: "#B00F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32031,
    stopColor: "#B21010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32422,
    stopColor: "#B31010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32813,
    stopColor: "#B51010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33203,
    stopColor: "#B61010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33594,
    stopColor: "#B81010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33984,
    stopColor: "#BA1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#B11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34766,
    stopColor: "#BD1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35156,
    stopColor: "#BF1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35547,
    stopColor: "#C01111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35938,
    stopColor: "#C21212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36328,
    stopColor: "#C41212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36719,
    stopColor: "#C51212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37109,
    stopColor: "#C71212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#C91212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37891,
    stopColor: "#CA1313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38281,
    stopColor: "#CC1313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38672,
    stopColor: "#CE1313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39063,
    stopColor: "#CF1313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39453,
    stopColor: "#D11313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39844,
    stopColor: "#D21414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40234,
    stopColor: "#D41414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#D61414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41016,
    stopColor: "#D71414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41406,
    stopColor: "#D91414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41797,
    stopColor: "#DB1515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42188,
    stopColor: "#DC1515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42578,
    stopColor: "#DE1515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42969,
    stopColor: "#E01515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43359,
    stopColor: "#E11515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#E31616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44141,
    stopColor: "#E51616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44531,
    stopColor: "#E61616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44922,
    stopColor: "#E81616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45313,
    stopColor: "#E91616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45703,
    stopColor: "#EB1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46094,
    stopColor: "#ED1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46484,
    stopColor: "#EE1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#F01717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47266,
    stopColor: "#F21717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47656,
    stopColor: "#F31818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48047,
    stopColor: "#F51818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48438,
    stopColor: "#F71818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48828,
    stopColor: "#F81818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49219,
    stopColor: "#FA1818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49609,
    stopColor: "#FC1919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FD1919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.50391,
    stopColor: "#FE1919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.50781,
    stopColor: "#FF1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51172,
    stopColor: "#FF1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51563,
    stopColor: "#FF1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51953,
    stopColor: "#FF1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52344,
    stopColor: "#FF2020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52734,
    stopColor: "#FF2121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53516,
    stopColor: "#FF2424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53906,
    stopColor: "#FF2525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54297,
    stopColor: "#FF2626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54688,
    stopColor: "#FF2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55078,
    stopColor: "#FF2929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55469,
    stopColor: "#FF2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55859,
    stopColor: "#FF2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FF2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56641,
    stopColor: "#FF2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57031,
    stopColor: "#FF3030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57422,
    stopColor: "#FF3131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57813,
    stopColor: "#F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58203,
    stopColor: "#FF3434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58594,
    stopColor: "#FF3636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58984,
    stopColor: "#FF3737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#FF3838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59766,
    stopColor: "#FF3A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60156,
    stopColor: "#FF3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60547,
    stopColor: "#FF3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60938,
    stopColor: "#FF3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61328,
    stopColor: "#FF3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61719,
    stopColor: "#FF4040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62109,
    stopColor: "#FF4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FF4343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62891,
    stopColor: "#FF4545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63281,
    stopColor: "#FF4646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63672,
    stopColor: "#FF4747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64063,
    stopColor: "#FF4949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64453,
    stopColor: "#FF4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64844,
    stopColor: "#FF4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65234,
    stopColor: "#FF4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FF4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66016,
    stopColor: "#FF4F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66406,
    stopColor: "#FF5151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66797,
    stopColor: "#FF5252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67188,
    stopColor: "#FF5454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67578,
    stopColor: "#F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67969,
    stopColor: "#FF5656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68359,
    stopColor: "#FF5858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FF5959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69141,
    stopColor: "#FF5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69531,
    stopColor: "#FF5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69922,
    stopColor: "#FF5D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70313,
    stopColor: "#FF5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70703,
    stopColor: "#FF6060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71094,
    stopColor: "#FF6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71484,
    stopColor: "#FF6363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#FF6464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72266,
    stopColor: "#FF6565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72656,
    stopColor: "#FF6767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73047,
    stopColor: "#FF6868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73438,
    stopColor: "#FF6969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73828,
    stopColor: "#FF6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74219,
    stopColor: "#FF6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74609,
    stopColor: "#FF6E6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF6F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75391,
    stopColor: "#FF7070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75781,
    stopColor: "#FF7272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76172,
    stopColor: "#FF7373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76563,
    stopColor: "#FF7474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76953,
    stopColor: "#FF7676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77344,
    stopColor: "#F77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77734,
    stopColor: "#FF7878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FF7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78516,
    stopColor: "#FF7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78906,
    stopColor: "#FF7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79297,
    stopColor: "#FF7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79688,
    stopColor: "#FF7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.80078,
    stopColor: "#FF8181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.80469,
    stopColor: "#FF8282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.80859,
    stopColor: "#FF8383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FF8585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81641,
    stopColor: "#FF8686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82031,
    stopColor: "#FF8787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82422,
    stopColor: "#FF8989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82813,
    stopColor: "#FF8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83203,
    stopColor: "#FF8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83594,
    stopColor: "#FF8D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83984,
    stopColor: "#FF8E8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#FF9090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84766,
    stopColor: "#FF9191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85156,
    stopColor: "#FF9292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85547,
    stopColor: "#FF9494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85938,
    stopColor: "#FF9595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86328,
    stopColor: "#FF9797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86719,
    stopColor: "#FF9898"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87109,
    stopColor: "#F99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FF9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87891,
    stopColor: "#FF9C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88281,
    stopColor: "#FF9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88672,
    stopColor: "#FF9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89063,
    stopColor: "#FFA0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89453,
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89844,
    stopColor: "#FFA3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90234,
    stopColor: "#FFA4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FFA6A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91016,
    stopColor: "#FFA7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91406,
    stopColor: "#FFA8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91797,
    stopColor: "#FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92188,
    stopColor: "#FFABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92578,
    stopColor: "#FFACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92969,
    stopColor: "#FFAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93359,
    stopColor: "#FFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#FFB0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94141,
    stopColor: "#FFB2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94531,
    stopColor: "#FFB3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94922,
    stopColor: "#FFB5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95313,
    stopColor: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95703,
    stopColor: "#FFB7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96094,
    stopColor: "#FFB9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96484,
    stopColor: "#FFBABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97266,
    stopColor: "#FFBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97656,
    stopColor: "#FFBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98047,
    stopColor: "#FFC0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98438,
    stopColor: "#FFC1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98828,
    stopColor: "#FFC2C2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99219,
    stopColor: "#FFC4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99609,
    stopColor: "#FFC4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC5C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 0.70197,
    x2: 0.29805,
    y1: 1.68575,
    y2: -0.68572
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#A50E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00391,
    stopColor: "#A60E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00781,
    stopColor: "#A70E0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01172,
    stopColor: "#A90F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01563,
    stopColor: "#AA0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01953,
    stopColor: "#AB0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02344,
    stopColor: "#AD0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02734,
    stopColor: "#AE0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03125,
    stopColor: "#AF0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03516,
    stopColor: "#B01010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03906,
    stopColor: "#B21010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04297,
    stopColor: "#B31010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04688,
    stopColor: "#B41010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05078,
    stopColor: "#B61010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05469,
    stopColor: "#B71010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05859,
    stopColor: "#B81010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0625,
    stopColor: "#BA1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06641,
    stopColor: "#B11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07031,
    stopColor: "#BC1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07422,
    stopColor: "#BD1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07813,
    stopColor: "#BF1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08203,
    stopColor: "#C01111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08594,
    stopColor: "#C11212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08984,
    stopColor: "#C31212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#C41212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09766,
    stopColor: "#C51212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10156,
    stopColor: "#C61212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10547,
    stopColor: "#C81212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.10938,
    stopColor: "#C91212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11328,
    stopColor: "#CA1313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11719,
    stopColor: "#CC1313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12109,
    stopColor: "#CD1313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#CE1313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12891,
    stopColor: "#D01313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13281,
    stopColor: "#D11313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13672,
    stopColor: "#D21414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14063,
    stopColor: "#D31414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14453,
    stopColor: "#D51414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14844,
    stopColor: "#D61414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15234,
    stopColor: "#D71414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15625,
    stopColor: "#D91414"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16016,
    stopColor: "#DA1515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16406,
    stopColor: "#DB1515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16797,
    stopColor: "#DD1515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17188,
    stopColor: "#DE1515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17578,
    stopColor: "#DF1515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17969,
    stopColor: "#E01515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18359,
    stopColor: "#E21515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1875,
    stopColor: "#E31616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19141,
    stopColor: "#E41616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19531,
    stopColor: "#E61616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19922,
    stopColor: "#E71616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20313,
    stopColor: "#E81616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.20703,
    stopColor: "#E91616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21094,
    stopColor: "#EB1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21484,
    stopColor: "#EC1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#ED1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22266,
    stopColor: "#EF1717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22656,
    stopColor: "#F01717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23047,
    stopColor: "#F11717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23438,
    stopColor: "#F31717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23828,
    stopColor: "#F41818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24219,
    stopColor: "#F51818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24609,
    stopColor: "#F61818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F81818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25391,
    stopColor: "#F91818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25781,
    stopColor: "#FA1818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26172,
    stopColor: "#FC1919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26563,
    stopColor: "#FD1919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26953,
    stopColor: "#FE1919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27344,
    stopColor: "#FF1919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27734,
    stopColor: "#FF1A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#FF1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28516,
    stopColor: "#FF1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28906,
    stopColor: "#FF1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29297,
    stopColor: "#FF1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29688,
    stopColor: "#FF2020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.30078,
    stopColor: "#FF2121"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.30469,
    stopColor: "#F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.30859,
    stopColor: "#FF2323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#FF2424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31641,
    stopColor: "#FF2525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32031,
    stopColor: "#FF2626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32422,
    stopColor: "#FF2727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32813,
    stopColor: "#FF2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33203,
    stopColor: "#FF2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33594,
    stopColor: "#FF2B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33984,
    stopColor: "#FF2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34375,
    stopColor: "#FF2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34766,
    stopColor: "#FF2E2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35156,
    stopColor: "#FF2F2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35547,
    stopColor: "#FF3030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35938,
    stopColor: "#FF3131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36328,
    stopColor: "#FF3232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36719,
    stopColor: "#F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37109,
    stopColor: "#FF3434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#FF3535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37891,
    stopColor: "#FF3636"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38281,
    stopColor: "#FF3838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38672,
    stopColor: "#FF3939"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39063,
    stopColor: "#FF3A3A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39453,
    stopColor: "#FF3B3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39844,
    stopColor: "#FF3C3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40234,
    stopColor: "#FF3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FF3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41016,
    stopColor: "#FF3F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41406,
    stopColor: "#FF4040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41797,
    stopColor: "#FF4141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42188,
    stopColor: "#FF4242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42578,
    stopColor: "#FF4343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42969,
    stopColor: "#F44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43359,
    stopColor: "#FF4646"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#FF4747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44141,
    stopColor: "#FF4848"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44531,
    stopColor: "#FF4949"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44922,
    stopColor: "#FF4A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45313,
    stopColor: "#FF4B4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45703,
    stopColor: "#FF4C4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46094,
    stopColor: "#FF4D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46484,
    stopColor: "#FF4E4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FF4F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47266,
    stopColor: "#FF5050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47656,
    stopColor: "#FF5151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48047,
    stopColor: "#FF5353"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48438,
    stopColor: "#FF5454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48828,
    stopColor: "#F55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49219,
    stopColor: "#FF5656"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49609,
    stopColor: "#FF5757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF5858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.50391,
    stopColor: "#FF5959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.50781,
    stopColor: "#FF5A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51172,
    stopColor: "#FF5B5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51563,
    stopColor: "#FF5C5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51953,
    stopColor: "#FF5D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52344,
    stopColor: "#FF5E5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52734,
    stopColor: "#FF5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#FF6161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53516,
    stopColor: "#FF6262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53906,
    stopColor: "#FF6363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54297,
    stopColor: "#FF6464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54688,
    stopColor: "#FF6565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55078,
    stopColor: "#F66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55469,
    stopColor: "#FF6767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55859,
    stopColor: "#FF6868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#FF6969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56641,
    stopColor: "#FF6A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57031,
    stopColor: "#FF6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57422,
    stopColor: "#FF6C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57813,
    stopColor: "#FF6D6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58203,
    stopColor: "#FF6F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58594,
    stopColor: "#FF7070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58984,
    stopColor: "#FF7171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#FF7272"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59766,
    stopColor: "#FF7373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60156,
    stopColor: "#FF7474"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60547,
    stopColor: "#FF7575"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60938,
    stopColor: "#FF7676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61328,
    stopColor: "#F77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61719,
    stopColor: "#FF7878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62109,
    stopColor: "#FF7979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#FF7A7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62891,
    stopColor: "#FF7B7B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63281,
    stopColor: "#FF7D7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63672,
    stopColor: "#FF7E7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64063,
    stopColor: "#FF7F7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64453,
    stopColor: "#FF8080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64844,
    stopColor: "#FF8181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65234,
    stopColor: "#FF8282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#FF8383"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66016,
    stopColor: "#FF8484"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66406,
    stopColor: "#FF8585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66797,
    stopColor: "#FF8686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67188,
    stopColor: "#FF8787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67578,
    stopColor: "#F88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67969,
    stopColor: "#FF8989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68359,
    stopColor: "#FF8B8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6875,
    stopColor: "#FF8C8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69141,
    stopColor: "#FF8D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69531,
    stopColor: "#FF8E8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69922,
    stopColor: "#FF8F8F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70313,
    stopColor: "#FF9090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.70703,
    stopColor: "#FF9191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71094,
    stopColor: "#FF9292"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71484,
    stopColor: "#FF9393"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#FF9494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72266,
    stopColor: "#FF9595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72656,
    stopColor: "#FF9696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73047,
    stopColor: "#FF9797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73438,
    stopColor: "#F99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73828,
    stopColor: "#FF9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74219,
    stopColor: "#FF9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74609,
    stopColor: "#FF9C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FF9D9D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75391,
    stopColor: "#FF9E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75781,
    stopColor: "#FF9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76172,
    stopColor: "#FFA0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76563,
    stopColor: "#FFA1A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76953,
    stopColor: "#FFA2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77344,
    stopColor: "#FFA3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77734,
    stopColor: "#FFA4A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#FFA5A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78516,
    stopColor: "#FFA7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78906,
    stopColor: "#FFA8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79297,
    stopColor: "#FFA9A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79688,
    stopColor: "#FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.80078,
    stopColor: "#FFABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.80469,
    stopColor: "#FFACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.80859,
    stopColor: "#FFADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#FFAEAE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81641,
    stopColor: "#FFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82031,
    stopColor: "#FFB0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82422,
    stopColor: "#FFB1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82813,
    stopColor: "#FFB2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83203,
    stopColor: "#FFB3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83594,
    stopColor: "#FFB5B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83984,
    stopColor: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84375,
    stopColor: "#FFB7B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84766,
    stopColor: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85156,
    stopColor: "#FFB9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85547,
    stopColor: "#FFBABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85938,
    stopColor: "#FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86328,
    stopColor: "#FFBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86719,
    stopColor: "#FFBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87109,
    stopColor: "#FFBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#FFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87891,
    stopColor: "#FFC0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88281,
    stopColor: "#FFC1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88672,
    stopColor: "#FFC3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89063,
    stopColor: "#FFC4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89453,
    stopColor: "#FFC4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89844,
    stopColor: "#FFC5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.90625,
    stopColor: "#FFC5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9375,
    stopColor: "#FFC5C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC5C5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M60.65625 0v128.89844h94.47656V0H60.65625zm0 0"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M36.16406 18.6289v110.26954h112.9336V18.6289H36.16406zm0 0"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M11.94922 51.39062v77.50782h131.46484V51.39062H11.94922zm0 0"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M0 91.75781v37.14063h137.10547V91.75781H0zm0 0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M579.88756 122.94654c-7.92969 0-14.33984-2.52344-19.23437-7.57813-4.88672-5.05078-7.32813-11.75781-7.32813-20.125V68.33716c0-8.80078 2.41406-15.89062 7.25-21.26562 4.83203-5.38282 11.21875-8.07813 19.15625-8.07813h13.35938c7.5 0 13.53125 2.01172 18.09375 6.03125 4.57031 4.02344 6.85937 9.29297 6.85937 15.8125h-5.54687c0-5-1.79688-9.01953-5.39063-12.0625-3.58594-3.03906-8.25781-4.5625-14.01562-4.5625h-13.35938c-6.19922 0-11.19922 2.20313-15 6.60938-3.80469 4.39843-5.70312 10.23437-5.70312 17.51562v26.90625c0 6.74219 1.89843 12.17969 5.70312 16.3125 3.80078 4.125 8.85156 6.1875 15.15625 6.1875h13.375c5.97656 0 10.75781-1.98437 14.34375-5.95312 3.58203-3.96875 5.375-9.21094 5.375-15.73438h5.54688c0 8.04297-2.3125 14.53906-6.9375 19.48438-4.61719 4.9375-10.72657 7.40625-18.32813 7.40625h-13.375zm86.07897 0c-8.26171 0-14.91796-2.66016-19.96875-7.98438-5.05468-5.32031-7.57812-12.27344-7.57812-20.85937v-26.25c0-8.59375 2.57812-15.55078 7.73437-20.875 5.16407-5.32032 11.92969-7.98438 20.29688-7.98438h12.23437c8.47657 0 15.29688 2.63672 20.45313 7.90625 5.16406 5.27344 7.75 12.25781 7.75 20.95313v26.25c0 8.6875-2.60938 15.66797-7.82813 20.9375-5.21875 5.27343-12.12109 7.90625-20.70312 7.90625h-12.39063zm12.39063-5.20313c6.84375 0 12.35937-2.17187 16.54687-6.51562 4.1875-4.35157 6.28125-10.0625 6.28125-17.125v-26.25c0-7.0625-2.07031-12.76563-6.20312-17.10938-4.125-4.35156-9.55859-6.53125-16.29688-6.53125h-12.23437c-6.74219 0-12.14844 2.17969-16.21875 6.53125-4.07422 4.34375-6.10938 10.04688-6.10938 17.10938v26.25c0 7.0625 2.00782 12.77343 6.03125 17.125 4.01954 4.34375 9.28907 6.51562 15.8125 6.51562h12.39063zm53.94966-77.45312h5.54687v14.35937c2.5-4.78125 5.83594-8.58203 10.01563-11.40625 4.1875-2.83203 8.45703-4.25 12.8125-4.25h12.0625c7.82031 0 14.125 2.60938 18.90625 7.82813s7.17187 12.12109 7.17187 20.70312v24.125c0 9.46094-2.36718 17.04297-7.09375 22.75-4.71875 5.69922-11.15625 8.54688-19.3125 8.54688h-12.0625c-4.35547 0-8.49218-1.32813-12.40625-3.98438-3.90625-2.66406-7.21875-6.22656-9.9375-10.6875v45.8125h-5.70312V40.29029zm40.10937 77.45312c6.41407 0 11.46875-2.36328 15.15625-7.09375 3.69532-4.72656 5.54688-11.0625 5.54688-19v-24.125c0-7.0625-1.85156-12.71094-5.54688-16.95312-3.6875-4.23828-8.63281-6.35938-14.82812-6.35938h-12.0625c-4.89844 0-9.46485 2.1211-13.70313 6.35938-4.24218 4.24218-7.23047 8.96875-8.96875 14.1875v31.625c.75782 3.14843 2.17188 6.38281 4.23438 9.70312 2.07031 3.3125 4.65625 6.08594 7.75 8.3125 3.10156 2.23047 6.55469 3.34375 10.35937 3.34375h12.0625zm74.8163 37c-6.1875 0-11.29297-1.60547-15.3125-4.8125-4.02344-3.21094-6.30859-7.41797-6.85938-12.625h5.71875c.42579 3.6875 2.13282 6.64453 5.125 8.875 2.98829 2.22656 6.76563 3.34375 11.32813 3.34375h13.04687c6.19532 0 11.17188-2.17969 14.92188-6.53125 3.75-4.34375 5.625-10.04687 5.625-17.10937v-21.03125c-3.26172 5.21875-7.07031 9.32421-11.42188 12.3125-4.34375 2.99218-8.63671 4.48437-12.875 4.48437h-10.59375c-6.74218 0-12.20312-2.30469-16.39062-6.92187-4.17969-4.625-6.26563-10.6875-6.26563-18.1875v-56.25h5.70313v56.25c0 5.98046 1.54687 10.79296 4.64062 14.4375 3.10157 3.63671 7.20704 5.45312 12.3125 5.45312h10.26563c3.03906 0 6.24219-1.03125 9.60937-3.09375 3.375-2.0625 6.42188-4.80469 9.14063-8.23437 2.71875-3.42579 4.67578-7.09375 5.875-11v-53.8125h5.70312v85.59375c0 8.69531-2.39062 15.67968-7.17187 20.95312-4.78125 5.26953-11.14063 7.90625-19.07813 7.90625h-13.04687zM218.662 121.63112c-4.66797 0-8.46875-1.41016-11.40625-4.23437-2.92969-2.82032-4.39063-6.51563-4.39063-11.07813V7.64675h86.96875V27.178h-64.5v26.39062h59.60938v19.53125h-59.60938v28.98438h64.5v19.54687H218.662zm117.40213 0c-3.14844 0-5.77735-.83594-7.89063-2.51562-2.11718-1.6875-3.93359-4.375-5.45312-8.0625l-28.01563-70.6875h23.29688l19.20312 55.85937h.32813l19.375-55.85937h23.29687l-32.73437 81.26562h-11.40625zm84.83798 1.29688c-6.83594 0-12.88672-1.27344-18.15625-3.8125-5.26172-2.55079-9.35938-6.13282-12.29688-10.75-2.92968-4.61329-4.39062-9.91016-4.39062-15.89063v-21c0-6.40625 1.46094-12.05078 4.39062-16.9375 2.9375-4.88281 7.03516-8.67969 12.29688-11.39062 5.26953-2.71875 11.32031-4.07813 18.15625-4.07813h13.03125c10.42578 0 18.78515 2.93359 25.07812 8.79688 6.30078 5.86718 9.45313 13.68359 9.45313 23.45312v17.25h-60.26563v3.90625c0 3.58594 1.14063 6.46484 3.42188 8.64063 2.28125 2.16796 5.375 3.25 9.28125 3.25h12.70312c3.80078 0 6.86719-.83594 9.20313-2.51563 2.33203-1.6875 3.5-3.88281 3.5-6.59375h21.82812c0 5.42969-1.46875 10.26172-4.40625 14.5-2.92968 4.23047-7.02734 7.48438-12.29687 9.76563-5.26172 2.26953-11.3125 3.40625-18.15625 3.40625h-12.375zm25.73437-50.3125v-1.29688c0-4.23828-1.14062-7.63281-3.42187-10.1875-2.28125-2.55078-5.32031-3.82812-9.10938-3.82812h-13.20312c-3.90625 0-7.05469 1.35937-9.4375 4.07812-2.38672 2.71094-3.57813 6.29297-3.57813 10.75v.48438h38.75zm36.79153-32.25h20.53125v10.42187c2.0625-3.14453 5.01953-5.71875 8.875-7.71875 3.85156-2.00781 7.89453-3.01562 12.125-3.01562h11.07813v19.20312h-11.07813c-5.75 0-10.41797 1.74219-14 5.21875-3.58594 3.46875-5.375 7.91797-5.375 13.34375v43.8125h-22.15625V40.3655zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.f03230a1f06214299b11c0cddd361274.svg";
export { ForwardRef as ReactComponent };